import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import Bird from '../animations/Bird';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import EndDialog from '../ui/EndDialog';
import { getGameBackground } from './GameBackground';
import Intro from './Intro';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class EndScreen extends Phaser.Scene
{
    static get KEY() { return 'EndScreen'; }

    constructor()
    {
        super({ key: (EndScreen).KEY });
    }

    create()
    {
        this.bird = new Bird(this);
        this.bird.x = -(this.bird.body.width + 50);

        this.endDialog = new EndDialog(this, this.scale.width / 2, 100, gameData.gameTime, gameData.bestTime);
        this.add.existing(this.endDialog);

        this.time.delayedCall(100, this.startEnd, null, this);
    }

    startEnd()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bird_jump_fly_tween, this);
        this.bird.flyTo(this.scale.width / 2 + (gameData.isMobile ? 100 : 200), this.scale.height - (this.bird.body.height) - 150, 1500);
        ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._great_job, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        this.endDialog.showDialog();
        this.endDialog.once("END_DIALOG", this.finishEnd, this);
    }

    finishEnd()
    {
        getGameBackground().pan("up");
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._basket_menu_tween, this);
        this.bird.flyTo(this.scale.width + 50, -(this.bird.body.height * 2), 1500);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bird_jump_fly_tween, this);
        ABCyaPhaser.Tweens.addTween(this.endDialog, 1000, { y: this.scale.height + 100 });
        this.time.delayedCall(1800, this.returnToIntro, null, this);
    }

    returnToIntro()
    {
        this.scene.start(Intro.KEY);
    }
}